// extracted by mini-css-extract-plugin
module.exports = {"removeInnerShadow":"input_removeInnerShadow__1IZ1h"};